module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_m_leucistic.6ee55b70.png";